import { tv } from "tailwind-variants"

export const disabledWrapperVariants = tv({
  base: "flex disabled:cursor-not-allowed",
  variants: {
    disabled: {
      true: "cursor-not-allowed",
    },
  },
})
